/* eslint-disable import/prefer-default-export */
import {
  SEND_WHATSAPP_POST_REQUEST,
  SEND_WHATSAPP_POST_SUCCESS,
  SEND_WHATSAPP_POST_ERROR,
} from 'Redux/types/sendWhatsAppTypes';

import { CALL_ACTIONS } from 'Redux/middleware';
import { BACKEND_URL_QUOTATION } from 'Config/routes';

const postSendWhatsapp = (phones, idQuotation) => (
  {
    [CALL_ACTIONS]: {
      TYPES: [SEND_WHATSAPP_POST_REQUEST, SEND_WHATSAPP_POST_SUCCESS, SEND_WHATSAPP_POST_ERROR],
      ENDPOINT: `${BACKEND_URL_QUOTATION}${idQuotation}/send_whatsapp/`,
      METHOD: 'POST',
      DATA: { phones: phones.toString() },
    },
  }
);

export const sendWhatsApp = (data) => (dispatch) => dispatch(postSendWhatsapp(data.phones, data.idQuotation));
